// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1__a089d16362e57990d090","cls2":"ImpactHubProfileCard-cls2___7e2ff176a5afef4ed27 ImpactHubProfileCard-cls1__a089d16362e57990d090"};